import React from 'react';
import { Skeleton } from '@mui/material';

import './mobile-vertical-product-thumbnail-skeleton-style.scss';

import { SKELETON_COLOR } from "@src/utils/constants";

const MobileVerticalProductThumbnailSkeleton = () => {
  return (
    <div className="mobile-vertical-product-thumbnail-skeleton-wrapper">
      <Skeleton variant="rectangular" width={148} height={175} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 6 }} />

      <div className="text-wrapper">
        <Skeleton variant="text" width={113} height={22} style={{ backgroundColor: SKELETON_COLOR }} />
        <div className="low-gap-text-area">
          <Skeleton variant="text" width="100%" height={12} style={{ backgroundColor: SKELETON_COLOR }} />
          <Skeleton variant="text" width={113} height={12} style={{ backgroundColor: SKELETON_COLOR }} />
        </div>
        <Skeleton variant="text" width={80} height={26} style={{ backgroundColor: SKELETON_COLOR }} />
      </div>
    </div>
  );
};

export default MobileVerticalProductThumbnailSkeleton;
